import { useMutation } from 'react-query';
import {
  addConversationParticipant,
  claimConversation,
  endConversation,
} from './heroApiClient';

export const useClaimConversation = () => {
  return useMutation(
    ['claimConversation'],
    ({
      conversationId,
      associateId,
    }: {
      conversationId: string;
      associateId: string;
    }) => claimConversation({ conversationId, associateId })
  );
};

export const useAddConversationParticipant = () => {
  return useMutation(
    ['addConversationParticipant'],
    ({
      conversationId,
      userToAdd,
    }: {
      conversationId: string;
      userToAdd: string;
    }) => addConversationParticipant({ conversationId, userToAdd })
  );
};

export const useEndConversation = () => {
  return useMutation(['endConversation'], (conversationId: string) =>
    endConversation(conversationId)
  );
};
